// ---------------------------
// Phone Formatting Helpers
// ---------------------------
const normalizePhone = (value) => {
  if (!value) return "";

  // Keep leading + if present, strip everything else non-digit
  const hasPlus = value.trim().startsWith("+");
  const digits = value.replace(/\D/g, "");

  if (hasPlus) {
    return `+${digits}`;
  }

  return digits;
};

const formatUsPhone = (digits) => {
  const area = digits.slice(0, 3);
  const mid = digits.slice(3, 6);
  const last = digits.slice(6, 10);
  return `(${area}) ${mid}-${last}`;
};

const withUsCountryCode = (formattedPhone, includeCountryCode) =>
  includeCountryCode ? `+1 ${formattedPhone}` : formattedPhone;

export const formatPhone = (value, options = {}) => {
  const { includeCountryCode = false } = options;

  if (!value) return "—";

  const normalized = normalizePhone(value);

  // ---------------------------
  // International (starts with +)
  // ---------------------------
  if (normalized.startsWith("+")) {
    const digits = normalized.slice(1);

    // +1 (US with country code)
    if (digits.length === 11 && digits.startsWith("1")) {
      return `+1 ${formatUsPhone(digits.slice(1))}`;
    }

    // Generic international formatting: +CC rest grouped
    return `+${digits.replace(/(\d{1,3})(\d+)/, "$1 $2")}`;
  }

  // ---------------------------
  // US without country code
  // ---------------------------
  if (normalized.length === 11 && normalized.startsWith("1")) {
    return withUsCountryCode(formatUsPhone(normalized.slice(1)), includeCountryCode);
  }

  if (normalized.length === 10) {
    return withUsCountryCode(formatUsPhone(normalized), includeCountryCode);
  }

  // Local numbers occasionally arrive without an area code.
  // Zero-pad them so they still render in the same fixed US shape.
  if (normalized.length >= 7 && normalized.length < 10) {
    return withUsCountryCode(
      formatUsPhone(normalized.padStart(10, "0")),
      includeCountryCode,
    );
  }

  // ---------------------------
  // Fallback
  // ---------------------------
  return normalized;
};
